function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { isEqual } from 'lodash-es';
import pluralize from 'pluralize';
import { useOverlayContext, GridItem, useDevice, MobileSummaryCard, Row, Typography, Badge, Column, Grid, BottomSheetContentLayout } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStore } from "../../../../contexts";
import { useContactsMap } from "../../../../hooks/reactQuery/derived/useContactsMap";
import { selectors } from "../../../../store/state-selectors";
import AddAdditionalRecipients from "../AddAdditionalRecipients/AddAdditionalRecipients";
import ContactDetails from "../ContactDetails/ContactDetails";
import SignatoryCheckbox from "../SignatoryCheckbox/SignatoryCheckbox";
import styles from "./Recipients.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const {
  MobileRecipientsTID
} = getTestIds();
function RecipientsBottomSheetContent(props) {
  const {
    contactDetailsProps,
    reviewers,
    showReviewerErrors,
    onReviewersChange,
    isSampleRelationship
  } = props;
  const {
    existingContact,
    disabled,
    onChange
  } = contactDetailsProps;
  const {
    popBottomSheetPage
  } = useOverlayContext();
  const worksAt = useStore(selectors.user.business);
  const {
    contactsMap,
    sampleContact
  } = useContactsMap(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
  const [tempIsSampleRelationship, setTempIsSampleRelationship] = useState(isSampleRelationship);
  const [tempClientContactId, setTempClientContactId] = useState(existingContact === null || existingContact === void 0 ? void 0 : existingContact.id());
  const [tempReviewers, setTempReviewers] = useState(reviewers);
  const tempContact = tempIsSampleRelationship ? sampleContact : tempClientContactId ? contactsMap[tempClientContactId] : undefined;
  function handleSave() {
    const existingContactId = existingContact === null || existingContact === void 0 ? void 0 : existingContact.id();
    if (tempClientContactId !== existingContactId) {
      if (tempIsSampleRelationship) {
        onChange({
          type: 'sampleContact'
        });
      } else if (!tempClientContactId) {
        onChange({
          type: 'noContact'
        });
      } else {
        onChange({
          type: 'existingContact',
          id: tempClientContactId
        });
      }
    }
    if (!isEqual(reviewers, tempReviewers)) {
      onReviewersChange(tempReviewers);
    }
    popBottomSheetPage();
  }
  function handleChange(change) {
    switch (change.type) {
      case 'existingContact':
        setTempIsSampleRelationship(false);
        setTempClientContactId(change.id);
        break;
      case 'sampleContact':
        setTempIsSampleRelationship(true);
        setTempClientContactId(sampleContact.id());
        break;
      case 'noContact':
        setTempIsSampleRelationship(false);
        setTempClientContactId(undefined);
        break;
    }
  }
  return /*#__PURE__*/_jsx(BottomSheetContentLayout, {
    header: {
      title: 'Recipients'
    },
    footer: {
      primaryAction: {
        text: 'Save',
        testId: MobileRecipientsTID.BottomSheet.Save(),
        onClick: handleSave
      }
    },
    children: /*#__PURE__*/_jsx("div", {
      className: styles.bottomSheetContent,
      children: /*#__PURE__*/_jsxs(Grid, {
        align: "center",
        rowGap: 8,
        children: [/*#__PURE__*/_jsx(ContactDetails, _objectSpread(_objectSpread({}, contactDetailsProps), {}, {
          hideEditContact: true,
          existingContact: tempContact,
          onChange: handleChange
        })), /*#__PURE__*/_jsx(AddAdditionalRecipients, {
          inBottomSheet: true,
          primaryContact: tempContact,
          initialState: tempReviewers,
          showReviewerErrors: showReviewerErrors,
          disabled: disabled,
          onChange: setTempReviewers
        })]
      })
    })
  });
}
function MobileRecipients(props) {
  const {
    contactDetailsProps,
    reviewers
  } = props;
  const {
    existingContact
  } = contactDetailsProps;
  const {
    pushBottomSheetPage
  } = useOverlayContext();
  function openRecipientsBottomSheet() {
    pushBottomSheetPage({
      content: /*#__PURE__*/_jsx(RecipientsBottomSheetContent, _objectSpread({}, props))
    });
  }
  return /*#__PURE__*/_jsx(GridItem, {
    span: 12,
    children: /*#__PURE__*/_jsx(MobileSummaryCard, {
      title: "Recipients",
      editButtonTestId: MobileRecipientsTID.Card.Edit(),
      onEdit: openRecipientsBottomSheet,
      body: /*#__PURE__*/_jsxs(Column, {
        gap: 4,
        children: [/*#__PURE__*/_jsx(Row, {
          alignItems: "center",
          gap: 4,
          children: existingContact ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Typography, {
              "data-testid": MobileRecipientsTID.Card.Primary(),
              children: existingContact.fullName()
            }), reviewers.length > 0 && /*#__PURE__*/_jsx(Badge, {
              rounded: true,
              outlined: true,
              skin: "primary",
              "data-testid": MobileRecipientsTID.Card.Badge(),
              children: "Primary contact"
            })]
          }) : /*#__PURE__*/_jsx(Typography, {
            "data-testid": MobileRecipientsTID.Card.Primary(),
            children: "Select a contact"
          })
        }), reviewers.length > 0 && /*#__PURE__*/_jsxs(Typography, {
          "data-testid": MobileRecipientsTID.Card.Reviewers(),
          children: ["+", pluralize('additional recipient', reviewers.length, true)]
        })]
      })
    })
  });
}
export function Recipients(props) {
  const {
    contactDetailsProps,
    reviewers,
    showReviewerErrors,
    onReviewersChange,
    amendmentInfoCallout
  } = props;
  const {
    existingContact,
    disabled
  } = contactDetailsProps;
  const {
    isMobileDevice
  } = useDevice();
  return isMobileDevice ? /*#__PURE__*/_jsx(MobileRecipients, _objectSpread({}, props)) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ContactDetails, _objectSpread({}, contactDetailsProps)), reviewers.length > 0 && /*#__PURE__*/_jsx(GridItem, {
      span: 12,
      children: /*#__PURE__*/_jsx(SignatoryCheckbox, {
        info: 'The primary contact must sign the proposal.',
        checkboxTestid: 'primary-contact-required-sign-checkbox',
        value: true,
        disabled: true,
        infoTestid: 'primary-contact-required-sign-checkbox-info'
      })
    }), /*#__PURE__*/_jsx(AddAdditionalRecipients, {
      primaryContact: existingContact,
      amendmentInfoCallout: amendmentInfoCallout,
      initialState: reviewers,
      showReviewerErrors: showReviewerErrors,
      disabled: disabled,
      onChange: onReviewersChange
    })]
  });
}